import './styles.css'

const Body = () => (
  <div className='body' />
)

export default Body